export default "__VITE_ASSET__$Uz2JHrPn9gid3VmLp8wGA__";